import { deleteBy } from './db.js';
import { sendHandover } from '../rpc/handover.js';

export async function enqueue(db, item) {
  const now = new Date().toISOString();
  const row = { ...item, client_at: item.client_at ?? now };
  await db.put('outbox', row);
  await db.put('handovers', {
    id: `local:${item.client_id}`,
    client_id: item.client_id,
    family_key: item.family_key,
    collected_name: item.collected_name,
    created_at: now,
    local_status: 'pending',
  });
}

export async function drainOutbox(db, token, sendFn = sendHandover) {
  const items = await db.getAll('outbox');
  const counts = { ok: 0, duplicate: 0, taken: 0, frozen: 0, notEligible: 0, errored: 0 };
  for (const item of items) {
    let res;
    try {
      res = await sendFn(token, {
        clientId: item.client_id,
        familyKey: item.family_key,
        scannedMemberId: item.scanned_member_id,
        collectedMemberId: item.collected_member_id,
        collectedName: item.collected_name,
        designatedName: item.designated_name,
        substitute: item.substitute,
        reason: item.reason,
        clientAt: item.client_at,
        device: item.device,
      });
    } catch (e) {
      counts.errored += 1;
      continue;
    }
    const local = await db.get('handovers', `local:${item.client_id}`);
    if (res.status === 'ok' || res.status === 'duplicate') {
      const server = res.handover || {
        id: res.id,
        family_key: item.family_key,
        client_id: item.client_id,
        collected_name: item.collected_name,
      };
      await deleteBy(db, 'handovers', `local:${item.client_id}`);
      await db.put('handovers', { ...server, local_status: 'confirmed' });
      await deleteBy(db, 'outbox', item.client_id);
      counts[res.status] += 1;
    } else if (res.status === 'taken') {
      await db.put('handovers', {
        ...(local || {}),
        local_status: 'conflict',
        server_winner: res.handover,
      });
      await deleteBy(db, 'outbox', item.client_id);
      counts.taken += 1;
    } else if (res.status === 'frozen') {
      counts.frozen += 1;
      break; // stop draining this cycle
    } else if (res.status === 'not_eligible') {
      await db.put('handovers', { ...(local || {}), local_status: 'invalid' });
      await deleteBy(db, 'outbox', item.client_id);
      counts.notEligible += 1;
    }
  }
  return counts;
}
